var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgLeaderboardIconActive(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.755 2H5.245A3.245 3.245 0 002 5.245v13.51A3.245 3.245 0 005.245 22h13.51A3.245 3.245 0 0022 18.755V5.245A3.245 3.245 0 0018.755 2z",
    fill: "#F7E8A1",
    fillOpacity: 0.2,
    stroke: "#D8BA6F",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17V9M12 17v-5",
    stroke: "#D8BA6F",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 4.567V19.43A3.57 3.57 0 0119.433 23H4.57A3.57 3.57 0 011 19.43V4.567A3.57 3.57 0 014.57 1h14.863A3.57 3.57 0 0123 4.567z",
    fill: "#6CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.372 1c0 7.404-7.136 16.4-16.372 16.4V4.563A3.57 3.57 0 014.57 1h12.802z",
    fill: "#80E0C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 9.176v9.871c-.002.299-.1.585-.274.796a.853.853 0 01-.655.328h-1.154a.857.857 0 01-.647-.333 1.266 1.266 0 01-.27-.79V9.175c0-.148.023-.295.07-.432a1.17 1.17 0 01.2-.367.938.938 0 01.3-.245.785.785 0 01.356-.087h1.154c.245.002.48.122.652.334.172.212.269.499.268.797zM13.7 13.354v5.693c-.002.298-.1.584-.272.794a.85.85 0 01-.65.33h-1.15a.852.852 0 01-.655-.33 1.274 1.274 0 01-.273-.8v-5.687c0-.149.025-.296.072-.433.046-.137.115-.261.201-.366a.936.936 0 01.3-.244.78.78 0 01.355-.085h1.15a.85.85 0 01.651.331c.173.212.27.498.271.797zM8 5.135v13.912a1.268 1.268 0 01-.276.796.855.855 0 01-.656.328h-1.14a.857.857 0 01-.655-.332A1.27 1.27 0 015 19.04V5.135c0-.15.023-.297.07-.434.046-.138.115-.263.201-.368a.94.94 0 01.302-.247A.787.787 0 015.929 4h1.14c.122 0 .243.029.356.085a.94.94 0 01.303.246c.087.106.155.231.202.369.047.138.07.285.07.435z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h22v22H0z"
  })))));
}
export default SvgLeaderboardIconActive;